import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ROUTE_NAME, ROUTE_PATH } from 'utils/constants/router';

class PrivateRoute extends React.Component {
  shouldComponentUpdate(nextProps) {
    return !(this.props.loggedIn === nextProps.loggedIn && this.props.component === nextProps.component);
  }

  render() {
    const { loggedIn, component: Component, ...rest } = this.props;
    return (
      <Route
        {...rest}
        render={(props) => (
          loggedIn ? <Component {...props} /> : <Redirect to={ROUTE_PATH[ROUTE_NAME.HOME]} />
        )}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  loggedIn: !!(state.authentication && state.authentication.loggedIn && state.authentication.user),
});

PrivateRoute.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
};

export default withRouter(connect(mapStateToProps)(PrivateRoute));
